export default __webpack_public_path__ + "static/media/ticket6.8291a0fc.jpg";